<template>
  <a-modal
    v-model="visible"
    :footer="null"
    :title="null"
    width="500px"
    :maskClosable="false"
    :keyboard="false"
    centered
    :closable="false"
    :getContainer="getContainer"
  >
    <a-result :status="res.code == 1 ? 'error' : 'success'">
      <template #icon>
        <a-icon
          :type="
            confirmLoading
              ? 'loading'
              : res.code == 0
              ? 'check-circle'
              : 'close-circle'
          "
        />
      </template>
      <template #title>
        <div v-if="confirmLoading">录入中，请稍后</div>
        <div v-else>{{ res.code == 0 ? "自动录入成功！" : "录入失败" }}</div>
      </template>

      <template #subTitle>
        <div v-if="!confirmLoading">
          {{
            res.code == 0
              ? `姓名：${res.data.name} 身份证号：${res.data.id_no.substring(
                  0,
                  6
                )}...${res.data.id_no.substring(
                  res.data.id_no.length - 7,
                  res.data.id_no.length - 1
                )} 录入成功！`
              : res.message
              ? res.message
              : "请重试"
          }}
        </div>
      </template>
    </a-result>
  </a-modal>
</template>

<script>
export default {
  props: {
    confirmLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
      res: {},
    };
  },
  methods: {
    init() {
      this.res = {};
      this.visible = true;
    },
    result(res) {
      this.res = res;
      let a = setTimeout(
        () => {
          clearTimeout(a);
          this.visible = false;
          if (this.res.code != 0) this.$emit("resetForm");
        },
        res.code == 0 ? 4000 : 5000
      );
    },
    getContainer(){
      return document.getElementById("bodyContnet")
    },
  },
};
</script>

<style>
</style>